/* eslint-disable @nx/enforce-module-boundaries */
import { Alert } from '@investigator/shared/generated/graphql';
import {
  SanitizedAnomalyAlert,
  SanitizedMlAlert,
  SanitizedNoticeAlert,
  SanitizedSearchBasedAlert,
  SanitizedSuricataAlert,
  SanitizedYaraAlert,
} from '../../../features/detections/pages';
import { createContext, Dispatch, ReactNode, SetStateAction } from 'react';

export type SlideDrawerAlert =
  | Alert
  | SanitizedMlAlert
  | SanitizedNoticeAlert
  | SanitizedSuricataAlert
  | SanitizedSearchBasedAlert
  | SanitizedYaraAlert
  | SanitizedAnomalyAlert
  | null;

export type PortalType =
  | 'alert'
  | 'entity'
  | 'detection'
  | 'notes'
  | 'baseline';
export interface ISlideDrawerContext {
  portalType?: PortalType;
  setPortalType?: Dispatch<SetStateAction<PortalType | undefined>>;
  isSlideDrawerOpen?: boolean;
  setIsSlideDrawerOpen?: Dispatch<SetStateAction<boolean | undefined>>;
  slideDrawerTitle?: ReactNode;
  setSlideDrawerTitle?: Dispatch<SetStateAction<ReactNode>>;
  slideDrawerBody?: ReactNode;
  setSlideDrawerBody?: Dispatch<SetStateAction<ReactNode>>;
  slideDrawerActions?: ReactNode;
  setSlideDrawerActions?: Dispatch<SetStateAction<ReactNode>>;
  slideDrawerOnClose?: (() => void) | undefined;
  setSlideDrawerOnClose?: Dispatch<SetStateAction<(() => void) | undefined>>;
  isNotesDrawerLoading?: boolean;
  setIsNotesDrawerLoading?: Dispatch<SetStateAction<boolean | undefined>>;
  activeAlert?: SlideDrawerAlert;
  setActiveAlert?: Dispatch<SetStateAction<SlideDrawerAlert>>;
}

export const SlideDrawerContext = createContext<ISlideDrawerContext>({
  portalType: undefined,
  setPortalType: () => false,
  slideDrawerTitle: undefined,
  setSlideDrawerTitle: () => false,
  isSlideDrawerOpen: undefined,
  setIsSlideDrawerOpen: () => false,
  slideDrawerBody: undefined,
  setSlideDrawerBody: () => false,
  slideDrawerActions: undefined,
  setSlideDrawerActions: () => false,
  slideDrawerOnClose: () => false,
  setSlideDrawerOnClose: () => false,
  isNotesDrawerLoading: false,
  setIsNotesDrawerLoading: () => false,
});
